<template>
  <div class="list">
    <ul>
      <li v-for="(item,a) in Data" :key="a">
        <a @click="toDetail($event,item.ArticleID,item.Title)" v-html="item.Title"></a>
        [{{item.Page_Num}}-{{item.Page_NumEnd}}]
        (<span class="red">{{num==1?item.View_Times:item.Read_Times}}</span>)
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: [],
      num:0
    };
  },
  props: ["params",'type'],
  mounted() {
    this.$store
      .dispatch("_getXZPH", this.params)
      .then(res => {
        this.Data = res.data.Data;
      })
      .catch(err => {
        console.log(err);
      });

    if(this.type){
      if(this.type=='view'){
        this.num=1
      }else{
        this.num2
      }
    }

  },
  methods:{
    toDetail(e, id, title,type) {
      let path=''
      
     path="/digest?ArticleID=" + id
      
      e.preventDefault();
      let routeUrl = this.$router.resolve({
        path: path
      });
      window.open(routeUrl.href, "_blank");
    },
   
  }
  
};
</script>
<style scoped>

</style>